






















































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import VipApi from '@/api/vip/list'
@Component({
  components: {
    CustomForm,
  },
})
export default class WithDrawalList extends AbpBase {
  showWithDrawalDialog: boolean = false
  selectItem: any = {}
  withdrawObj: any = {
    status: 0,
    remark: '',
  }
  ruleValidate: any = {
    status: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
    remark: [{ required: true, message: '请输入审核说明', trigger: 'blur' }],
  }
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'filter',
    },
    {
      label: '审核状态：',
      type: 'select',
      key: 'reviewStatus',
      props: {
        placeholder: '请选择',
      },
      options: [
        {
          value: 0,
          text: '待审核',
        },
        {
          value: 1,
          text: '已通过',
        },
        {
          value: 2,
          text: '已拒绝',
        },
      ],
    },
  ]
  columns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center',
    // },
    {
      title: '姓名',
      key: 'name',
      align: 'center',
      // width: 150,
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
      // width: 150,
    },
    {
      title: '提现金额',
      key: 'withdrawnCash',
      align: 'center',
    },
    {
      title: '审核说明',
      key: 'description',
      align: 'center',
      // width: 100,
    },
    {
      title: '审核状态',
      key: 'reviewStatusStr',
      align: 'center',
    },
   
    {
      title: '申请时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '审核时间',
      slot: 'checkTime',
      align: 'center',
    },
     {
      title: '付款成功时间',
      slot: 'paymentTime',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      align: 'center',
    },
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  /**
   * 获取储值审核列表
   */
  getTableData(form = {}) {
    this.isCheckAll = false
    // let filter = form['filter']
    let { pageSize, currentPage } = this
    VipApi.getWithDrawalList(currentPage, pageSize, form)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  /**
   * 提交审核
   */
  putStoreWithDrawal(row) {
    this.withdrawObj.status = ''
    this.withdrawObj.remark = ''
    this.showWithDrawalDialog = true
    this.selectItem = row
  }
  handleWithDrawal() {
    (this.$refs['withdraw'] as any).validate((valid) => {
      if (valid) {
        this.$Message.success('Success!')
        let obj = {
          id: this.selectItem.id,
          reviewStatus: Number(this.withdrawObj.status),
          description: this.withdrawObj.remark
        }
        console.log(obj);
        VipApi.putStoreWithDrawal(obj).then(res => {
          this.$Notice.success({ desc: '审核成功' })
          this.showWithDrawalDialog = false
          this.getTableData()
        })
      }
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
}
